import { useTranslation } from "react-i18next";
import { MenuItem } from "@material-ui/core";
import { OptionGroup } from "components/Styled";
import SelectField from "components/Forms/SelectField";
import { StyledTitle } from "../Styled";
import { StorageTemplate } from "@dashboard-v3/api";

interface SelectMetadataKeyProps {
  options: StorageTemplate[];
  value: string;
  onChange: (e: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
  onBlur?: React.FocusEventHandler;
  error?: boolean;
  helperText?: string;
}

export default function SelectMetadataKey({
  options,
  value,
  onChange,
  onBlur,
  error = false,
  helperText,
}: SelectMetadataKeyProps) {
  const { t } = useTranslation("templateDefinitions");

  return (
    <OptionGroup>
      <StyledTitle>{t("form.metadataKey.title")}</StyledTitle>
      <SelectField
        name="metadataKey"
        label={t("form.metadataKey.label")}
        options={options}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        helperText={helperText}
        disabled={options.length < 1}
        data-testid="td-metadata-select"
        renderOption={({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        )}
      />
    </OptionGroup>
  );
}
